module.exports = __webpack_public_path__ + "static/media/p2.5721a3c4.jpeg";